module.exports = __webpack_public_path__ + "img/052-boy-24.606a894f.svg";